import { AdminReferralEntryResponse } from "../contracts/AdminReferralEntryResponse";
import { AdminReferralPartnerResponse } from "../contracts/AdminReferralPartnerResponse";
import { ReferralEntry } from "../models/ReferralEntry";
import { ReferralPartner } from "../models/ReferralPartner";

export const mapResponseToReferralPartner = (
  response: AdminReferralPartnerResponse
): ReferralPartner => ({
  id: response.id,
  name: response.name,
  email: response.email,
  code: response.code,
  notes: response.notes,
  acceptanceToken: response.acceptanceToken,
  termsVersion: response.termsVersion,
  termsAcceptedAt: response.termsAcceptedAt ? new Date(response.termsAcceptedAt) : null,
  dateCreated: new Date(response.dateCreated),
  referralCount: response.referralCount,
  convertedCount: response.convertedCount,
  unpaidAmountMinorUnits: response.unpaidAmountMinorUnits,
  paidAmountMinorUnits: response.paidAmountMinorUnits,
  bountyCurrency: response.bountyCurrency,
});

export const mapResponseToReferralEntry = (
  response: AdminReferralEntryResponse
): ReferralEntry => ({
  id: response.id,
  instructorId: response.instructorId,
  firstName: response.firstName,
  lastName: response.lastName,
  email: response.email,
  bountyAmountMinorUnits: response.bountyAmountMinorUnits,
  bountyCurrency: response.bountyCurrency,
  attributedAt: new Date(response.attributedAt),
  convertedAt: response.convertedAt ? new Date(response.convertedAt) : null,
  paidAt: response.paidAt ? new Date(response.paidAt) : null,
});
